import styled from "styled-components";
import RitualButton from "./global/RitualButton";

const CallToActionWrapper = styled.div`
  padding-top: var(--spacing-1);
  padding-bottom: var(--spacing-1);
  position: relative;

  @media (min-width: 933px) {
    padding-top: var(--spacing-1_5);
    padding-bottom: var(--spacing-1_5);
  }
`;

const BackgroundGradient = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 930px;
  height: 400px;
  border-radius: 930px;
  background: radial-gradient(
    50% 50% at 50% 50%,
    rgba(255, 214, 0, 0.8) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  z-index: -1;

  @media (min-width: 933px) {
    width: 1324px;
    height: 570px;
    border-radius: 1324px;
  }
`;

const StyledHeadline = styled.h2`
  margin-bottom: var(--spacing-0_75);

  em,
  i {
    font-family: var(--font-dutch);
  }

  @media (min-width: 933px) {
    margin-bottom: var(--spacing-1);
  }
`;

const StyledSubhead = styled.p`
  margin-bottom: var(--spacing-1_5);

  @media (min-width: 933px) {
    margin-bottom: var(--spacing-2);
  }
`;

const ButtonWrapper = styled.div`
  display: inline-block;
`;

type CallToActionModuleProps = {
  headline?: {
    childMarkdownRemark: {
      html: string;
    };
  };
  subhead?: {
    childMarkdownRemark: {
      html: string;
    };
  };
  link?: {
    text: string;
    to: {
      path: string;
    };
    ariaLabel?: string;
    role?: string;
    tabIndex?: number;
  };
};

const CallToActionModule = ({
  headline,
  subhead,
  link,
}: CallToActionModuleProps) => {
  return (
    <CallToActionWrapper className="d-flex align-center justify-center flex-column text-center">
      <BackgroundGradient />
      <StyledHeadline
        className="typography-headline2"
        dangerouslySetInnerHTML={{
          __html: headline?.childMarkdownRemark?.html || "",
        }}
      />
      <StyledSubhead
        className="typography-body1 font-circular"
        dangerouslySetInnerHTML={{
          __html: subhead?.childMarkdownRemark?.html || "",
        }}
      />
      {link && (
        <ButtonWrapper>
          <RitualButton
            to={link.to.path}
            ariaLabel={link.ariaLabel || link.text}
            role={link.role}
            tabIndex={link.tabIndex}
          >
            {link?.text}
          </RitualButton>
        </ButtonWrapper>
      )}
    </CallToActionWrapper>
  );
};

export default CallToActionModule;
